
























import { Component, Prop, Vue } from "vue-property-decorator";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { getCurrentUserId } from "@/plugins/roles";
import SelectEntity from "@/components/form/SelectEntity.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";

import {
  Registration as IRegistration,
  LearningProgress as ILearningProgress
} from "@/api-v2/course/models";
import { courseApi } from "@/getinfo-api";
import ProgressDonut from "@/components/form/ProgressDonut.vue";
import TextField from "@/components/form/CustomPage/textField.vue";

@Component({
  components: {
    TextField,
    ProgressDonut,
    CBlock,
    CField,
    CustomButton,
    SelectEntity
  }
})
export default class CourseV2ListenerProgress extends Vue {
  @Prop() registration!: IRegistration;
  progress!: ILearningProgress;

  data() {
    return {
      progress: undefined
    };
  }

  get userId() {
    return getCurrentUserId();
  }

  statusFormatter(status: string) {
    if (status === "learning") return `${this.$tc(this.$translate.Learning)}`;
    if (status === "pause") return `${this.$tc(this.$translate.Pause)}`;
    if (status === "success") return `${this.$tc(this.$translate.Success)}`;
    if (status === "fail") return `${this.$tc(this.$translate.Failed)}`;
    if (status === "abort") return `${this.$tc(this.$translate.Canceled)}`;
    return status;
  }

  getLearningProgress() {
    courseApi.LearningProgress.getLearningProgress(this.registration.id)
      .then(res => {
        this.progress = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  created() {
    this.getLearningProgress();
  }
}
